import classNames from 'classnames';
import { Star } from 'components/Icons';
import React from 'react';
import styles from './AppIcon.module.scss';

type AppIconSize = 'xsmall' | 'small' | 'medium' | 'bigmedium' | 'large' | 'xlarge';

export interface Props {
  path: string;
  size?: AppIconSize | null | undefined;
  type?: string;
  alt?: string;
  className?: string;
  isLockedFeature?: boolean;
}

export default class AppIcon extends React.Component<Props> {
  static defaultProps = {
    type: 'app',
  };

  render() {
    const { size, path, alt, className } = this.props;

    const sizeClass = size ? styles[size] : styles.medium;
    const img = <img className={classNames(sizeClass, className)} alt={alt} src={path} />;
    if (this.props.isLockedFeature) {
      return (
        <div className={styles.lockedContainer}>
          <Star className={styles.lockedFeature} />
          {img}
        </div>
      );
    }
    return img;
  }
}
